import { useActivityCurrentUserRole, useActivityPermissions } from "PFApp/activities/hooks";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useActivityTabsStoreActions } from "PFApp/activities/show/store";
import { Button } from "PFComponents/button";
import { Typography } from "PFComponents/typography";
import NoShortlistIllustration from "PFTheme/graphics/illustrations/illustration-no-shortlist.svg";
import { useTranslation } from "react-i18next";

import css from "./shortlist_empty_state.module.scss";

export const ShortlistEmptyState = () => {
  const { t } = useTranslation("activities", { keyPrefix: "show.shortlist" });
  const activity = useCurrentActivity();
  const { changeTab } = useActivityTabsStoreActions();
  const { canSeeMatches } = useActivityPermissions(activity);

  const { isReviewer } = useActivityCurrentUserRole(activity);

  return (
    <div className={css.noItems}>
      <NoShortlistIllustration />
      <Typography withMargin variant="h1">
        {t("noShortlistedCandidates")}
      </Typography>

      {activity.coowned && (
        <Typography withMargin variant="h5" className={css.subtitle}>
          {t("shortlistVisibleToYou")}
          <br />
          {t("wontNotifyAnyone")}
        </Typography>
      )}
      {!isReviewer && canSeeMatches && (
        <Button kind="primary" text={t("viewMatches")} onClick={() => changeTab("matches")} />
      )}
    </div>
  );
};
